import apiClient from "../axiosClient";
import Filter from "../interfaces/filters";
import { apiCallWrapper, createQueryParam } from "../utils/commonUtils";

export default class CampaignJobService {
    public static async getCampaignJobs(filters: Filter[], campaignType: string) {
        const filterString = createQueryParam(filters, '', -1, '', false, []);
        const response = await apiCallWrapper(() => apiClient.get(`/api/v1/campaigns?${filterString}&campaign_type=${campaignType}`));
        if (response && response.status === 200) {
            return response.data;
        }
    }

    public static async getCampaignJobResults(campaignType: string, jobID: string, pageIndex: number = 0) {
        const response = await apiCallWrapper(() => apiClient.get(`/api/v1/campaigns/${campaignType}/${jobID}?page_index=${pageIndex}`));
        if (response && response.status === 200) {
            return response.data;
        }
    }

    public static async getCallCampaignAggregations(jobID: string) {
        const response = await apiCallWrapper(() => apiClient.get(`/api/v1/campaigns/call-campaign/${jobID}/aggregates`));
        if (response && response.status === 200) {
            return response.data;
        }
    }
};